import { AbstractControl } from '@angular/forms';

export function noWhitespaceValidator(control: AbstractControl): { whitespace: boolean } | null {
  const onlyWhitespace =
    control.value &&
    control.value.toString().length &&
    control.value.toString().trim().length === 0;
  const isValid = !onlyWhitespace;
  return isValid ? null : { whitespace: true };
}
